import { UPLOAD_IMAGE_MICROSCOPY } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';


const uploadImageMicroscopy = createAsyncThunk('uploadImageMicroscopy', async (formData:FormData) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = UPLOAD_IMAGE_MICROSCOPY
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default uploadImageMicroscopy;
